import $ from 'jquery';
import { checkUid } from './utilities';



export default class formValidator {
    constructor() {
        this.form = form;
    }

    static validateForm(form) {
        let valid = false;
        const validations = [];
        form.find('input:not([type="submit"],[data-type="uid"],[data-type="plz"]),textarea,select').each(function () {
            const formElement = $(this);
            validations.push(formValidator.validateInput(formElement));
        });
        if (!validations.includes(false)) {
            valid = true;
        }
        return valid;
    }

    static validateInput(formElement) {
        let valid = false;
        const validations = [];
        const form = formElement.parents('form').first();
        if (this.isRequired(formElement)) {
            validations.push(this.hasValue(formElement));
            if (formElement.attr('type') == 'number') {
                validations.push(this.hasValidMin(formElement));
                validations.push(this.hasValidMax(formElement));
            }
            if (formElement.attr('type') == 'checkbox' || formElement.attr('type') == 'radio') {
                validations.push(this.isChecked(formElement));
            }
            if (formElement.attr('type') == 'email') {
                validations.push(this.isEmail(formElement));
            }
            if (formElement.attr('data-type') == 'date') {
                validations.push(this.isDate(formElement));
            }
            if (formElement.attr('data-type') == 'password') {
                validations.push(this.isPassword(formElement));
            }
        } else {
            validations.push(true);

        }
        if (!validations.includes(false)) {
            valid = true;
        }
        this.toggleInvalidClass(formElement, valid);
        return valid;
    }

    static validateAllElements(form) {
        form.find('input:not([type="submit"]),textarea,select').each(function () {
            const formElement = $(this);
            formValidator.validateInput(formElement);
        });
    }
    static validateOnInput(form) {
        form.find('input:not([type="submit"]),textarea,select').on('input change', function () {
            const formElement = $(this);
            formValidator.validateInput(formElement);
        });
    }

    static isRequired(formElement) {
        let required = false;
        if (formElement.attr('required')) {
            required = true;
        }
        return required;
    }

    static hasValue(formElement) {
        let hasValue = false;
        if (formElement.val() != '') {
            hasValue = true;
        }
        return hasValue;
    }

    static hasValidMin(formElement) {
        let hasValidMin = false;
        const min = formElement.attr('min');
        if (min) {
            if (this.hasValue(formElement)) {
                if (parseInt(min) <= parseInt(formElement.val())) {
                    hasValidMin = true;
                }
            }
        } else {
            hasValidMin = true;
        }
        return hasValidMin;
    }

    static hasValidMax(formElement) {
        let hasValidMax = false;
        const max = formElement.attr('max');
        if (max) {
            if (this.hasValue(formElement)) {
                if (parseInt(max) >= parseInt(formElement.val())) {
                    hasValidMax = true;
                }
            }
        } else {
            hasValidMax = true;
        }
        return hasValidMax;
    }

    static hasValidMinMax(formElement) {
        let hasValidMin = false;
        let hasValidMax = false;
        const min = parseFloat(formElement.attr('min'));
        const max = parseFloat(formElement.attr('max'));
        const val = parseFloat(formElement.val());

        if (val && min) {
            if (this.hasValue(formElement)) {
                if (min <= val) {
                    hasValidMin = true;
                }
            }
        } else {
            hasValidMin = true;
        }
        if (val && max) {
            if (this.hasValue(formElement)) {
                if (max >= val) {
                    hasValidMax = true;
                }
            }
        } else {
            hasValidMax = true;
        }
        if (hasValidMin && hasValidMax) {
            return true;
        }

        return false;

    }

    static isChecked(formElement) {
        let isChecked = false;
        const name = formElement.attr('name');
        if ($('input[name="' + name + '"]:checked').length > 0) {
            isChecked = true;
        }
        return isChecked;
    }

    static isCheckboxGroupValid(name) {
        let isValid = false;
        if ($('input[name="' + name + '"]:checked').length > 0) {
            isValid = true;
        }
        return isValid;
    }

    static isEmail(formElement) {
        var mail = formElement.val().trim();
        var regEx = new RegExp('^([a-zA-Z0-9\\-\\.\\_]+)(\\@)([a-zA-Z0-9\\-\\.]+)(\\.)([a-zA-Z]{2,20})$');
        if (!mail.match(regEx)) {
            return false;
        }
        return true;
    }

    static isPassword(formElement) {
        var pass = formElement.val().trim();
        const regex = new RegExp('^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$', 'gm');
        if (regex.exec(pass) === null) {
            return false;
        }
        return true;
    }

    static isDate(formElement) {
        var date = formElement.val().trim();
        var regEx = new RegExp('(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}');
        if (!date.match(regEx)) {
            return false;
        }
        return true;
    }

    static isUId(formElement) {
        const rawVal = formElement.val();
        const cleanSyntax = /[^A-Z0-9]/gm;
        const subst = ``;
        const val = rawVal.replace(cleanSyntax, subst);

        const regex = /^((DE)[0-9]{9}|(LU)[0-9]{8})$/gm;

        // const regex = /^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$/gm;
        const found = val.match(regex);

        if (found && found.length > 0) {
            formElement.siblings('.form-error.not-valid').hide();
            return true;
        } else {
            formElement.siblings('.form-error.not-valid').show();
            return false;
        }
    }

    static async isPLZ(formElement) {
        const plz = formElement.val().trim();
        const land = formElement.attr('id') == 'bil_plz' ? $('#bil_land').val() : $('#ship_land').val();

        let result = await $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ajax_object.ajaxUrl,
            data: {
                'action': 'checkPLZ',
                'security': ajax_object.security,
                'plz': plz,
                'land': land
            }
        });

        if (result.val) {
            formElement.siblings('.form-error.not-valid').hide();
            return true;
        } else {
            formElement.siblings('.form-error.not-valid').show();
            return false;
        }
    }

    static toggleInvalidClass(formElement, validity) {
        const formGroup = formElement.parents('.form-input').first();
        if (validity) {
            formGroup.removeClass('invalid');
        } else {
            formGroup.addClass('invalid');
        }
    }
}